import { Box, Image, ImageProps } from '@chakra-ui/react';
import React from 'react';

import { isStaticImageDef } from '../Utils';

interface HeroImageProps {
  image: StaticImageDef | React.ReactNode;
  height: ImageProps['height'];
}

const HeroImage: React.FC<HeroImageProps> = ({ image, height }) => {
  if (!image) {
    return null;
  }
  if (isStaticImageDef(image)) {
    return (
      <Image
        src={image.src}
        srcSet={image.srcset}
        sizes={image.sizes}
        alt={image.description}
        height={height}
        width="100%"
        objectFit="cover"
      />
    );
  }

  return (
    <Box height={height} width="100%">
      {image}
    </Box>
  );
};

export default HeroImage;
